import React from "react"
import {StyledGridContent} from "./components"

const StandardGridContent = ({props, children}: any) => {
    return <StyledGridContent {...props}>{children}</StyledGridContent>
}

export default StandardGridContent
